<div class="snap-container">
  <header>
    <smm-header></smm-header>
    <smm-mobile-menu />
  </header>
  <router-outlet></router-outlet>
  <footer class="snap-section">
    <smm-footer></smm-footer>
  </footer>
</div>
